import { Shark, Utils } from "shark-mvc";
import moment from "moment";

import NousCoreModel from "./NousCoreModel";

class Task extends NousCoreModel {
	static STATUS_ARCHIVED = 4;
	static STATUS_CANCELED = 3;
	static STATUS_CLOSE = 2;
	static STATUS_OPEN = 1;

	activityGuid = "";
	assigneeGuid = "";
	attachmentGuidList = [];
	body = "";
	closedAt = "0000-00-00 00:00:00";
	closedByGuid = "";
	endNotes = "";
	expireAt = "0000-00-00 00:00:00";
	name = "";
	noteCount = 0;
	priority = 3;
	projectGuid = "";
	sortOrder = 0;
	tags = [];
	
	__assigneeName = "";
	__attachmentList = [];
	__closedAtLabel = "";
	__expireAt = "";
	__expireAtLabel = "";
	__hasAttachments = false;
	__originalSortOrder = 0;
	__refCode = "";
	__statusCSSClass = "";
	__statusLabel = "";

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		let exportData = super.export();

		exportData.attachmentGuidList = this.exportArrayField("attachmentGuidList");
		exportData.expireAt = this.exportDateField("expireAt");
		exportData.tags = this.exportArrayField("tags");

		// exportData.done = this.done ? 1 : 0;
		// const refCodeInNameIndex = this.name.indexOf("#");
		// if (refCodeInNameIndex > -1) {
		// 	exportData.name = this.name.substr(0, refCodeInNameIndex) + "<span class=\"linkedToBox\" data-refcode=\"" + this.name.substr(refCodeInNameIndex, 9) + "\" data-toggle=\"tooltip\" data-placement=\"right\"><span class=\"icon-linkedtotask\"></span> " + this.name.substr(refCodeInNameIndex, 9) + "</span>" + this.name.substr(refCodeInNameIndex + 9);
		// }

		return exportData;
	}

	import (data) {
		super.import(data);

		if (this.importDateField("closedAt", data.closedAt)) {
			this.__closedAtLabel = this.closedAt.format("DD/MM/YYYY");
		}

		if (this.importDateField("expireAt", data.expireAt)) {
			this.__expireAt = this.expireAt.format("YYYY-MM-DD");
			this.__expireAtLabel = this.expireAt.format("DD/MM/YYYY");
		}

		this.importNumberField("noteCount", data.noteCount);
		this.importNumberField("sortOrder", data.sortOrder);

		this.__originalSortOrder = this.sortOrder;
		
		this.__htmlBody = this.body.replace(/\n/g, "<br>");
		this.__userIsAssignee = Shark.$store.loggedUser.guid === this.assigneeGuid;
		this.__userIsOwner = Shark.$store.loggedUser.guid === this.createdByGuid;

		this.__attachmentList = this.attachmentGuidList.map(item => {
			return {
				guid: item.guid,
				renderCSSClassList: "attachment-loading",
			};
		});

		this.__hasAttachments = this.attachmentGuidList.length > 0;

		if (data.guid && data.guid !== "") {
			this.__refCode = data.guid.slice(0, 8);
		}

		this.parseAssignee();
		this.parseStatus();
	}

	onDataChanged (data) {
		console.log({data});
		
	}

	on__expireAtChanged () {
		console.log(this);
		this.expireAt = moment(this.__expireAt);
	}

	parseAssignee () {
		if (this.assigneeGuid !== "") {
			if (Shark.$store.userList) {
				const assignee = Utils.safp(Shark.$store.userList, "guid", this.assigneeGuid);

				if (assignee) {
					this.__assigneeName = assignee.__fullName;
				}
			}
		}
		else {
			this.__assigneeName = "Chiunque";
		}
	}

	parseStatus () {
		this.__editable = [Task.STATUS_OPEN].includes(this.status);

		switch (this.status) {
			case Task.STATUS_OPEN:
				this.__statusCSSClass = "";
				this.__statusLabel = "Aperto"
				break;
			case Task.STATUS_CLOSE:
				this.__statusCSSClass = "bg-success bg-opacity-50 text-dark";
				this.__statusLabel = "Chiuso"
				break;
			case Task.STATUS_CANCELED:
				this.__statusCSSClass = "bg-warning bg-opacity-50";
				this.__statusLabel = "Annullato"
				break;
			case Task.STATUS_ARCHIVED:
				this.__statusCSSClass = "bg-info bg-opacity-50";
				this.__statusLabel = "Archiviato"
				break;
		}
	}

	validate () {
		const errors = [];

		if (this.name.trim() === "") {
			errors.push({
				error: "Il titolo del Task è obbligatorio.",
				field: "name",
			});
		}

		return errors;
	}
}

Shark.registerModel("Task", Task);

export default Task;
